import { render, staticRenderFns } from "./UserMain.vue?vue&type=template&id=89ba46fc&scoped=true&"
import script from "./UserMain.vue?vue&type=script&lang=js&"
export * from "./UserMain.vue?vue&type=script&lang=js&"
import style0 from "./UserMain.vue?vue&type=style&index=0&id=89ba46fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ba46fc",
  null
  
)

export default component.exports